import React from 'react';

import { texts } from 'utils/languages/fr';
import { PasswordField } from 'components';
import { Box, Typography } from '@mui/material';

const PasswordForm = props => {
    const {
        classes,
        form,
        errors,
        user,
        handleChange,
        title = texts.VEUILEZ_SAISIR_MOT_DE_PASSE,
    } = props;

    return (
        <React.Fragment>
            {!user && (
                <Typography align="left" variant="body1" gutterBottom>
                    {title}
                </Typography>
            )}
            <Box
                display="flex"
                position="relative"
                justifyContent="space-between"
                alignItems="baseline"
                flexWrap="wrap"
            >
                <Typography align="left" variant="caption" gutterBottom paragraph>
                    {texts.LE_MOT_DE_PASSE_DOIT_CONTENIR}
                </Typography>
                <PasswordField
                    inputStyle={classes.field}
                    label={texts.MOT_DE_PASSE}
                    value={form.password}
                    disabled={!!user}
                    onChange={handleChange('password')}
                    error={errors.password}
                />
                <PasswordField
                    inputStyle={classes.field}
                    label={texts.CONFIRM_PASSWORD}
                    disabled={!!user}
                    value={form.confirmPassword}
                    onChange={handleChange('confirmPassword')}
                    error={errors.confirmPassword}
                />
            </Box>
        </React.Fragment>
    );
};

export default PasswordForm;
